// extracted by mini-css-extract-plugin
export default {"link":"VideoLink_link__qfZlk","name":"VideoLink_name__8vWl-","img":"VideoLink_img__ovY6u"};